import {ItemToolEditor} from "./CreatePriceGroup.jsx";
export default function CreateVariation(props){return <ItemToolEditor {...props} kind="variation"/>;}
